<template>
  <ModalViewerContentPdf
    v-if="showAsPdf"
    :offset-top="offsetTop"
    :pdf-object="pdfObject"
    :title="post.title"
  />
  <ModalViewerContentPost
    v-else
    :post="post"
    :pdf-object="pdfObject"
    :m-medias="mMedias"
  />
</template>
<script setup lang="ts">
import { saveRecommendationOpenedAt } from '~/lib/recommendation';

interface Props {
  offsetTop: number;
}

defineProps({
  offsetTop: null
});

const { $db } = useNuxtApp();

const { disciplineId } = inject(INJECT_CATEGORY_PAGE);

const { showAsPdf, mMedias, post } = inject(INJECT_MODAL_CATEGORY);

const mediaIds = computed<string[]>(() =>
  (post.value.medias || []).map((m) => m.id)
);

const pdfObject = computed(() => {
  const medias = Array.from(mMedias.value.values()).filter((media) =>
    mediaIds.value.includes(media.id)
  );
  return medias.find((m) => m.mime === 'application/pdf');
});

const { category } = inject(INJECT_MODAL_CATEGORY);

const appEvent = useAppEventPost(category, disciplineId, post);

saveRecommendationOpenedAt($db, 'post', post.value.id);

onMounted(() => {
  saveRecommendationOpenedAt($db, 'post', post.value.id);
  appEvent.init();
});

onBeforeUnmount(() => {
  appEvent.release();
});
</script>
